module.exports = __webpack_public_path__ + "static/img/line.7b71409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/line.jpg
// module id = uGRg
// module chunks = 1